import { render } from "./realtime-monitor.vue?vue&type=template&id=497e056e"
import script from "./realtime-monitor.vue?vue&type=script&lang=js"
export * from "./realtime-monitor.vue?vue&type=script&lang=js"

import "./realtime-monitor.vue?vue&type=style&index=0&id=497e056e&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__